module.exports = __webpack_public_path__ + "img/en.e6ba901e.svg";